//组件时间筛选全局起始时间
function chageFormat (value = '') {
  return  Number( value.substring(0,value.length-1) )
}


export default {
  data () {
    return {
      c_begin_time:null, //储存时间
      c_end_time:null, //储存时间
    }
  },
  methods:{
    onDateChange (picker, values) {
      // console.log("picker",picker)
      // console.log('values',values)
      if ( chageFormat(values[0]) >  chageFormat(values[2]) ) {
        picker.setSlotValue(2, values[0])
      } else if ( chageFormat(values[0]) == chageFormat(values[2]) ) {
        if ( chageFormat(values[1]) > chageFormat(values[3]) ) {
          picker.setSlotValue(3, values[1])
        }
      }
      this.c_begin_time = `${chageFormat(values[0])}/${chageFormat(values[1])}`
      this.c_end_time = `${chageFormat(values[2])}/${chageFormat(values[3])}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/dateChange.js